export default "__VITE_ASSET__Cv4Tsw_N__";